import { useDispatch } from "react-redux";
import { useReactiveVar } from "@apollo/client";

import { cancelTenantInvite } from "../../../actions";
import { userManagementGenericErrorVar } from "../../apollo/LocalState";
import { SelectedTableEntry } from "../../tables/UsersTables";
import { EUserManagementGenericError } from "../../../interfaces/interfaces";
import { userManagementGenericErrorMessages } from "../../../utils/errorMessages";
import { renderUnitDetailsModalContent } from "../../../utils/utils";

export interface RemoveInvitedMemberProps {
  closeRemoveTenantModal: () => void;
  decreaseCurrentStep: () => void;
  emailAddress: string;
  propertyId: string;
}

const RemoveInvitedMember: React.FC<RemoveInvitedMemberProps> = ({
  closeRemoveTenantModal,
  decreaseCurrentStep,
  emailAddress,
  propertyId,
}) => {
  const dispatch = useDispatch();
  const userManagementGenericError = useReactiveVar(
    userManagementGenericErrorVar
  );
  return (
    <div className="tenants-show-body">
      <div
        className="tenants-show-description-container margin-left-right-small margin-top-small"
        data-testid="remove-invited-tenant-container"
      >
        Please confirm that you would like to cancel this Member&#39;s invite to
        join the Home.
        <div className="margin-top-small" />
        {renderUnitDetailsModalContent({
          descriptionList: [
            "The invite sent to the Home Member’s email will no longer be valid.",
            "The Home Member will not be able to join the Home.",
          ],
          title: "If you cancel the invite:",
        })}
      </div>
      <div className="tenants-show-description-body">
        <SelectedTableEntry />
      </div>
      {userManagementGenericError !== EUserManagementGenericError.noError && (
        <div
          data-testid="generic-error"
          className="tenants-show-description-error alert"
        >
          {
            userManagementGenericErrorMessages[
              EUserManagementGenericError[userManagementGenericError]
            ]
          }
        </div>
      )}
      <div className="invite-tenant-modal-actions margin-top-small">
        <button
          type="button"
          className="tertiary-btn-small tertiary-btn-small-alert"
          onClick={() => {
            decreaseCurrentStep();
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="tertiary-btn-small tertiary-btn-small-main tertiary-btn-small-main-alert invite-tenant-modal-actions-submit"
          onClick={() => {
            dispatch(
              cancelTenantInvite({
                emailAddress,
                propertyId,
              })
            );
            closeRemoveTenantModal();
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default RemoveInvitedMember;
